import React, { useEffect } from 'react'
import { useAuth } from 'react-oidc-context';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { useSearchParams } from 'react-router-dom';

import {
  SplashContainer,
  api,
  useAppSelector,
  clearAllAuthValues,
  PartnerCustomizations,
  IPartnerCustomizations,
  useAppDispatch,
  navConfig, ENavPages,
} from '../internal'

interface IProps extends WrappedComponentProps, IPartnerCustomizations {
  history: any,
  loading: boolean,
  darkModeActive: boolean,
}

const OidcLoginContainer: React.FC<IProps> = (props) => {

  const auth = useAuth();
  const dispatch = useAppDispatch();
  const [queryParams, _] = useSearchParams();

  const $loading: boolean = useAppSelector(state => state.authenticatedUser.loading);

  useEffect(() => {
    clearAllAuthValues();
    if (queryParams.has('continue') && !api.cacheImpl.get('continueTo')) {
      // store the continue in the cache since the oidc
      // authentication will take us away from the react app.
      // only write when nothing is cached yet so a spurious re-entry into
      // login (e.g. a redirectToLogin race on a fresh OIDC return) can't
      // clobber the destination set on the way out. the value is cleared by
      // the consumer in tokenRefreshDealerPortalBusiness, resetting this each cycle.
      api.cacheImpl.set('continueTo', encodeURIComponent(queryParams.get('continue') ?? ''));
    }

    auth.signinRedirect();

  }, [])

  return (
    <section className="access-container">
      <section className="login-container">

        <SplashContainer
          fromComponentName="oidclogin"
          darkModeActive={props.darkModeActive}
          externalRedirect={true} />

      </section>
    </section>
  )
}

export default PartnerCustomizations(injectIntl(OidcLoginContainer), {
  componentName: 'oidcLogin'
})
